import React from "react";
import Page from "components/Page";
import { Props } from "./StaticContents";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const StaticContents = lazyWithRetry(() => import("./StaticContents"));

export default (props: Props) => (
  <Page>
    <StaticContents {...props} />
  </Page>
);
